import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { LogisticsPermissions } from '../dashboard/shipment.model';

const permissionByPath: [string, LogisticsPermissions][] = [
  ['/logistics/warehouse', LogisticsPermissions.WarehouseContent],
  ['/logistics/release-orders', LogisticsPermissions.CanReadIssueOrders],
  ['/logistics/delivery-orders', LogisticsPermissions.CanReadReceiptOrders]
];

function getRequiredPermission(url: string): LogisticsPermissions {
  return permissionByPath.find(([path]) => url.includes(path))?.[1] ?? LogisticsPermissions.CanReadDocuments;
}

export const logisticsPermissionGuard: CanActivateChildFn = (_childRoute, state) => {
  const oauthService = inject(OAuthService);
  const router = inject(Router);

  const claims = oauthService.getIdentityClaims() || {};
  const permission = claims['extranet_modules_logistics_permissions'];
  const permissions: LogisticsPermissions[] = Array.isArray(permission) ? permission : (permission ? [permission] : []);

  const requiredPermission = getRequiredPermission(state.url);

  if (permissions.includes(requiredPermission)) {
    return true;
  }

  return router.createUrlTree(['/no-access']);
};
